import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  FormButtonStyled,
  LabelStyled,
  SpanStyled,
  TextStyled,
} from "../../../../../components/styled/Elements";
import CustomRadioButton from "../../../../../components/common/radioButtons/CustomRadio";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ValidatedInput from "../../../../../components/common/inputFields/ValidatedInput";
import { FileDown } from "../../../../../components/styled/AllImages";
import ValidationErrorText from "../../../../../components/common/inputFields/ValidationErrorText";
import { formateAmounts } from "../../../../../utils";
import { useUser } from "../../../../../context/userContext";
import BillingApi from "../../../../../services/api/billingApi";
import { toast } from "react-toastify";

const LicenseStep1 = ({
  planInfo,
  handleSteps,
  paymentMethod,
  bankInfo,
  totalAmount,
  setTotalAmount,
  setPaymentMethod,
  setValue,
  addLicenseFrm,
  register,
  watch,
  errors,
  onHide,
  action,
}) => {
  // const numOfLicenses = watch("number_of_licenses") || 0;
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user, fetchUserInfo } = useUser();
  const savedCard = user?.card_details;
  const selectedCardOption = watch("use_saved_card") || 0;

  const [submitLoading, setSubmitLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPaymentMethod(value);
    setValue(name, value);
  };

  const signUpStepTwo = async () => {
    setSubmitLoading(true);
    const baseCost = parseFloat(planInfo?.amount);
    const baseObj = {
      plan_id: planInfo?.id,
      plan_duration: planInfo?.duration || 1,
      amount: totalAmount,
      payment_method: paymentMethod,
      use_saved_card: selectedCardOption,
      // number_of_licenses: numOfLicenses,
      token_id: null,
      action: action,
      sub_total: baseCost,
      ...(bankInfo?.vat && {
        vat_percentage: bankInfo?.vat,
        vat_value: (parseFloat(bankInfo?.vat) / 100) * baseCost,
      }),
    };

    const formData = new FormData();
    Object.entries(baseObj).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const { code, message, data } = await BillingApi.upgradeOrgPlan(formData);
      if (code === 200) {
        if (paymentMethod === "card") {
          window.open(data?.payment_url, "_self");
          onHide();
        } else {
          fetchUserInfo();
          toast.success(message);
          onHide();
        }
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    if (planInfo?.amount) {
      const baseCost = parseFloat(planInfo?.amount);
      const vatAmount = (parseFloat(bankInfo?.vat) / 100) * baseCost;
      const totalAmount =
        parseFloat(baseCost.toFixed(2)) + parseFloat(vatAmount.toFixed(2));

      console.log(baseCost, vatAmount, totalAmount, bankInfo);

      setTotalAmount(formateAmounts(totalAmount));
      // setTotalAmount(totalAmount.toFixed(2));
    }
  }, [bankInfo, planInfo]);

  useEffect(() => {
    if (
      action === "extend" &&
      user?.current_organization?.plan_detail?.payment_method
    ) {
      setValue(
        "payment_method",
        user?.current_organization?.plan_detail?.payment_method
      );
      setPaymentMethod(user?.current_organization?.plan_detail?.payment_method);
    }
  }, [action, user]);

  return (
    <Step1Wrapper>
      <Box>
        <Box>
          {/* <ValidatedInput
            name="number_of_licenses"
            label={"num_of_licenses"}
            type="input"
            fieldType="number"
            placeholder={"numOfLicensePlaceholder"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          /> */}
        </Box>

        {addLicenseFrm && (
          <Box className="mb-3">
            <Box>
              <LabelStyled
                size="16px"
                weight="bold"
                color="var(--text)"
                className="mb-1"
              >
                {planInfo?.type === "private"
                  ? t("EnterprisePlanCustom")
                  : planInfo?.title
                  ? planInfo?.title
                  : language === "en"
                  ? user?.current_organization?.plan_detail?.plan?.title_en
                  : user?.current_organization?.plan_detail?.plan?.title_ar}
              </LabelStyled>
            </Box>
            <Box className="d-flex gap-3">
              <CustomRadioButton
                name="plan-type"
                label={`${planInfo.amount} ${t("usd")}`}
                value={1}
                checked={"checked"}
                className="w-auto"
                // onChange={handleChange}
              />
            </Box>
          </Box>
        )}

        <Box className="d-flex justify-content-between align-items-center flex-wrap gap-3 my-4">
          <Box>
            <TextStyled
              size="18px"
              color="var(--themeColor)"
              className="align-items-sm-baseline"
              weight="700"
            >
              {t("total")}: {totalAmount} {t("usd")}
              <SpanStyled size="14px">
                &nbsp; &nbsp;
                {t("inc_tax")}
              </SpanStyled>
            </TextStyled>
          </Box>
          {/* {!addLicenseFrm && (
            <Box>
              <ButtonStyled
                label={t("download_invoice")}
                border="var(--themeColor)"
                color="var(--themeColor)"
                bg="var(--white)"
                shadow="none"
                size="14px"
                type="button"
                icon={FileDown}
              />
            </Box>
          )} */}
        </Box>
        <Box className="mb-3">
          <Box>
            <LabelStyled
              size="16px"
              weight="bold"
              color="var(--text)"
              className="mb-1"
            >
              {t("choose_payment_method")}
            </LabelStyled>
          </Box>
          <Box className="d-flex gap-3">
            <CustomRadioButton
              name="payment_method"
              label={t("card")}
              value={"card"}
              checked={paymentMethod === "card"}
              register={register}
              disabled={
                action === "extend" &&
                user?.current_organization?.plan_detail?.payment_method &&
                user?.current_organization?.plan_detail?.payment_method !==
                  "card"
              }
              validationRules={{
                required: true,
                onChange: handleChange,
              }}
            />

            <CustomRadioButton
              name="payment_method"
              label={t("bank_transfer")}
              value={"bank_transfer"}
              checked={paymentMethod === "bank_transfer"}
              register={register}
              disabled={
                action === "extend" &&
                user?.current_organization?.plan_detail?.payment_method &&
                user?.current_organization?.plan_detail?.payment_method !==
                  "bank_transfer"
              }
              validationRules={{
                required: true,
                onChange: handleChange,
              }}
            />
          </Box>

          {paymentMethod === "card" && (
            <Box className="mt-3">
              {savedCard && (
                <CardOption
                  className={`mb-2 ${
                    parseInt(selectedCardOption) === 1 ? "active" : ""
                  }`}
                  onClick={() => setValue("use_saved_card", 1)}
                >
                  <input
                    type="radio"
                    name="card_option"
                    value={1}
                    checked={parseInt(selectedCardOption) === 1}
                    onChange={() => setValue("use_saved_card", 1)}
                  />
                  <CardDetails>
                    <span className="brand">{savedCard?.brand}</span>
                    <span className="digits">•••• {savedCard?.last_four}</span>
                    <span className="expiry">
                      {t("exp")}: {savedCard?.exp_month}/{savedCard?.exp_year}
                    </span>
                  </CardDetails>
                </CardOption>
              )}
              <CardOption
                className={!selectedCardOption ? "active" : ""}
                onClick={() => setValue("use_saved_card", 0)}
              >
                <input
                  type="radio"
                  name="card_option"
                  value="new_card"
                  checked={!selectedCardOption}
                  onChange={() => setValue("use_saved_card", 0)}
                />
                <CardDetails>
                  <span>{t("pay_with_new_card")}</span>
                </CardDetails>
              </CardOption>
            </Box>
          )}

          {errors?.payment_method?.type === "required" && (
            <ValidationErrorText
              text={
                t(errors?.payment_method?.message) ||
                `${t("payment_method")} ${t("isRequired")}.`
              }
            />
          )}
        </Box>
      </Box>
      <FormButtonStyled
        label={t("next")}
        color="var(--white)"
        bg="var(--themeColor)"
        className="w-100"
        clName="w-100 my-4"
        type="button"
        isLoading={submitLoading}
        disabled={!paymentMethod || submitLoading}
        onClick={(e) => paymentMethod === "card" && parseInt(selectedCardOption) === 1 ? signUpStepTwo() : handleSteps(e)}
      />
    </Step1Wrapper>
  );
};

export default LicenseStep1;

const Step1Wrapper = styled.div``;

const CardOption = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  border: 2px solid var(--borderColor, #ddd);
  border-radius: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: 0.3s ease;
  background: var(--white);

  &.active {
    border-color: var(--themeColor);
    background: #f9faff;
  }

  input {
    accent-color: var(--themeColor);
    cursor: pointer;
  }
`;

const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: var(--text);

  .brand {
    font-weight: 600;
  }
  .digits {
    font-size: 15px;
    letter-spacing: 2px;
  }
  .expiry {
    font-size: 12px;
    color: #888;
  }
`;
